import { FunctionalComponent, h } from '@stencil/core';

import { OwnerType, LocationType, InventoryType } from '@/types';
import { caiEvent } from '@/utils';
import { ELOT_ANALYTICS } from '@/constants/elotEvents';

import Text from '../Text';

interface DealerHeaderProps {
    owner?: OwnerType;
    inventory: Array<InventoryType>;
    location?: LocationType;
}

const DealerHeader: FunctionalComponent<DealerHeaderProps> = ({ owner = {}, inventory = [], location = {} }) => {
    const { id, name, logo, website } = owner;

    const carouselHeader = id ? `Cars for you at ${name}` : `Cars You May Like Near ${location?.city}, ${location?.state}`;

    const onDealerLogoClick = () => {
        caiEvent.send(ELOT_ANALYTICS, {
            action: 'ownerLogoClick',
            data: {
                ownerId: id,
                inventoryId: inventory[0].id,
            },
        });
        window.open(website?.href, "_blank");
    }

    const title = (
        <div class="display-flex justify-content-between margin-bottom-3">
            <div class="display-flex flex-column margin-left-1">
                <Text component="h2" size="600" weight="bold" content={carouselHeader} />
            </div>
            {id && (
                <div class="margin-left-auto cursor-pointer">
                    <img class="img-responsive display-block" loading="lazy" alt={name} src={logo?.src} onClick={() => onDealerLogoClick()} />
                </div>
            )}
        </div>
    );

    return title;
};

export default DealerHeader;